import React, { useContext, useEffect, useState } from 'react'
import { Card, CardBody, Col, Row } from 'reactstrap'
import { Link } from 'react-router-dom'
import Moment from 'react-moment'
import toastr from 'toastr'

import ApiService from '../../../data/services/ApiService'
import { GeneralContext } from '../../../context/'
import { getDashboardFacturasProgramadas } from '../../../helpers/facturasProgramadas'

const ProgramadasDashboard = () => {
    const { setLoading } = useContext(GeneralContext)
    const [programadas, setProgramadas] = useState([])
    const [fallidas, setFallidas] = useState([])

    useEffect(() => {
        ;(async () => {
            try {
                setLoading(true)
                const response = await ApiService.getFacturasProgramadas()
                const facturas = response.data?.data?.facturas || []
                const dashboardData = getDashboardFacturasProgramadas(facturas)

                setProgramadas(dashboardData.programadas)
                setFallidas(dashboardData.fallidas)
            } catch (error) {
                toastr.error('No pude cargar el resumen de facturas programadas.')
            } finally {
                setLoading(false)
            }
        })()

        // eslint-disable-next-line
    }, [])

    if (programadas.length < 1 && fallidas.length < 1) {
        return null
    }

    return (
        <Row className="mb-3">
            {programadas.length > 0 && (
                <Col lg={6}>
                    <Card>
                        <CardBody>
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5 className="mb-0">Próximas facturas programadas</h5>
                                <Link to="/facturas/programadas">Ver todas</Link>
                            </div>

                            {programadas.map((factura) => (
                                <div key={factura._id} className="mb-3">
                                    <strong>{factura.clientes?.[0]?.razonSocial || 'Sin receptor'}</strong><br />
                                    <small>
                                        <Moment format="DD/MM/YYYY HH:mm">
                                            {factura.schedule?.scheduledFor}
                                        </Moment>
                                        {factura.schedule?.isRecurring && ' · Recurrente'}
                                    </small>
                                </div>
                            ))}
                        </CardBody>
                    </Card>
                </Col>
            )}

            {fallidas.length > 0 && (
                <Col lg={6}>
                    <Card>
                        <CardBody>
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5 className="mb-0">Facturas programadas con error</h5>
                                <Link to="/facturas/programadas">Ver todas</Link>
                            </div>

                            {fallidas.map((factura) => (
                                <div key={factura._id} className="mb-3">
                                    <Link to={`/facturas/nueva/${factura._id}`}>
                                        {factura.clientes?.[0]?.razonSocial || 'Sin receptor'}
                                    </Link><br />
                                    <small>{factura.schedule?.errorReason || 'Sin detalle de error.'}</small>
                                </div>
                            ))}
                        </CardBody>
                    </Card>
                </Col>
            )}
        </Row>
    )
}

export default ProgramadasDashboard
